export default "__VITE_ASSET__Kz9BY3qe__"